import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
export function replaceUnderscoresWithSpace(inputStr) {
  return inputStr === null || inputStr === void 0 ? void 0 : inputStr.replace(/_/g, ' ');
}